import { createSelector } from '@reduxjs/toolkit';
import {
  selectOptionsPages,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
  selectProjectsDetails
} from '../project/projectSelectros';

export const selectWebFlow = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.webFlow || {}
);

export const selectWebFlowCalculationParams = createSelector(
  selectWebFlow,
  projectOther => projectOther.calculationOptions || {}
);

export const selectWebFlowPagesTotal = createSelector(
  selectOptionsPages,
  (options) => {
    const option = options.length ? options[0] : {};
    const {priceValue, priceValueStart, totalQuantity} = option;
    const totalPricePages = priceValueStart + (priceValue * totalQuantity);

    return {
      discount: 0,
      totalPricePages
    };
  }
);

export const selectWebFlowOptionsTotal = createSelector(
  selectWebFlowPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
)

export const selectWebFlowTotal = createSelector(
  selectWebFlowPagesTotal,
  selectWebFlowOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectWebFlowTotalForAsap = createSelector(
    selectWebFlowTotal,
    (totalPrice) => {
        return totalPrice / 2;
    }
);

export const selectWebFlowEta = createSelector(
  selectWebFlowCalculationParams,
  selectOptionsPages,
  ({etaForFirstPage, etaForOtherPage}, options) => {
    const option = options.length ? options[0] : {};
    const {totalQuantity} = option;
    const eta = (totalQuantity * etaForOtherPage) + etaForFirstPage;
    const etaText = `${eta} business days`;
    const etaIsExists = !!eta;

    return {
      etaText,
      etaIsExists,
    };
  }
);

export const selectWebFlowDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
